<template>
  <v-dialog v-model="dialog" persistent width="800" overlay-opacity="0.16">
    <v-card elevation="0" class="rounded-lg" >
      <v-app-bar :color="colors.white" elevation="0" prominent height="44" class="pa-2 pr-0">
        <v-spacer/>
        <v-btn
          class="branded-btn close-btn"
          :color="colors.grey"
          icon
          dark
          @click="close"
        >
          <v-icon size="36" :color="colors.black">mdi-close</v-icon>
        </v-btn>
      </v-app-bar>
              <v-card-title class="pt-3 justify-center">
            <h5 class="pb-4 dialog-title text-center">Пополнить баланс</h5>
        </v-card-title>
      <v-card-text>
          <v-row class="justify-space-between"> 
              <v-flex xs12 lg4
                 v-for="fee in fees"
                 :key="fee.product"
                 class="pe-4"
                 >
                   <v-card
                    elevation="1"
                    class="">
                        <v-card-title
                            :class="[
                            'text-center',
                            'justify-center',
                            'text-h4',
                            'text--blue',
                            'font-weight-bold',
                            ]"
                        >{{formattedNumber(fee.checks)}}</v-card-title>
                        <v-card-subtitle class="justify-center text-center">проверок</v-card-subtitle>
                        <v-card
                            flat
                            dark
                            :color="fee.color"
                            class="ma-4 pa-2">
                            <v-select
                                :items="quantitySelectItems"
                                v-model="quantitySelects[fee.product]"
                                item-text="quantity"
                                item-value="quantity"
                                label="Количество"
                                dense
                                outlined
                                hide-details
                                return-object
                                class="mt-4 ml-4 mr-4"
                             ></v-select>
                            <v-card-title
                                :class="[
                                'text-center',
                                'justify-center',
                                'text-h5',
                                'text--blue',
                                'font-weight-bold',
                                ]"
                            >{{ totalPrice(fee)}}</v-card-title>
                            <v-card-subtitle class="justify-center text-center">скидка {{ fee.discount}}%</v-card-subtitle>
                        </v-card>
                        <v-card-actions class="justify-center d-flex align-end mt-16">
                            <v-btn class="mb-3 pl-10 pr-10" color="primary" @click="pay(fee)">Оплатить</v-btn>
                        </v-card-actions>
                   </v-card>
              </v-flex>
          </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import ColorPaletteMixin from "@/mixins/ColorPalette";
import FormatMixin from "@/mixins/Format";
import { notificatonStatuses } from "@/enumerations";
import TimeoutGenerator from "@/helpers/TimeoutGenerator";

export default {
  props: {
  },
  mixins: [ColorPaletteMixin, FormatMixin],
  data() {
    return {
        quantitySelects: {
            "dataexpert_10k": { quantity: 1 },
            "dataexpert_50k": { quantity: 1 },
            "dataexpert_100k": { quantity: 1 },
        },
        quantitySelectItems: [...Array(10).keys()].map(k => k+1),
    };
  },
  computed: {
    ...mapGetters("profile", {
      company: "company",
    }),
    ...mapGetters("serviceModals", {
      dataExpertPricesModal: "dataExpertPricesModal",
    }),
    dialog: {
      get() {
        return this.dataExpertPricesModal.dialog;
      },
      set(dialog) {
        !dialog &&
          this.$store.commit("serviceModals/CLOSE_DATAEXPERT_PRICES_MODAL");
      },
    },
    fees() {
        return [
            {product: "dataexpert_10k", name: "Data Expert 10.000 проверок", checks: 10000, price: 15000, discount: 0, color: "pink darken-2"},
            {product: "dataexpert_50k", name: "Data Expert 50.000 проверок", checks: 50000, price: 70000, discount: 6, color: "purple darken-2"},
            {product: "dataexpert_100k", name: "Data Expert 100.000 проверок", checks: 100000, price: 130000, discount: 13, color: "teal darken-2"},
        ]
    }
  },
  methods: {
    close() {
      this.dialog = false;
    },
    pay(fee) {
        let widget = new window.cp.CloudPayments();
        let product = fee.product;
        let quantity = this.quantitySelects[fee.product]?.quantity || this.quantitySelects[fee.product];
        let amount = fee.price * quantity;
        let productName = fee.name;
        let paymentId = this.company.paymentId;
        var self = this;
        let totalChecks = fee.checks * quantity;
        widget.pay('charge', 
            { 
                publicId: process.env.VUE_APP_CLOUD_PAYMENTS_PID, 
                description: `${productName}, ${quantity} шт`,
                amount: amount, 
                currency: 'KZT', 
                accountId: this.company.email, 
                email: this.company.email,
                skin: "modern", 
                data: {
                    paymentId,
                    product,
                    quantity,
                }
            },
            {
                onSuccess: function () {
                  self.close();
                  self.showThankYouPopup(totalChecks);
                  self.$emit("onPaymentSuccessful", {
                    addedChecks: totalChecks
                  });
                },
                onFail: function (reason, options) { 
                if (reason !== "User has cancelled") {
                    self.showPaymentError(reason, options);
                }
                },
            }
        );
    },
    totalPrice(fee) {
        let { quantity } = this.quantitySelects[fee.product];
        return `${ this.toMoneyFormat(fee.price * (quantity || this.quantitySelects[fee.product])) } ₸`
    },
    showThankYouPopup(totalChecks) {
      this.$store.dispatch("core/setThankYouDialog", `Баланс проверок успешно пополнен на ${this.formattedNumber(totalChecks)}!`);
      this.$confetti.start();
      TimeoutGenerator.timeWait(1000).then(() => {
        this.$confetti.stop();
      });
    },
    showPaymentError(reason, options) {
      this.$store.commit('core/SET_NOTIFICATION', {
          status: notificatonStatuses.error,
          message: `Ошибка оплаты за ${options.description}. Причина: ${reason || "неизвестно"}`,
      });
    },
  },
};
</script>